import { InfoCircleFilled } from '@ant-design/icons';
import {
  Checkbox,
  Col,
  Flex,
  Form,
  Input,
  InputNumber,
  Radio,
  RadioChangeEvent,
  Row,
  Select,
  Space,
  Spin,
  Switch,
  Tooltip,
  Typography,
} from 'antd';
import { CheckboxChangeEvent } from 'antd/es/checkbox';
import { Rule } from 'antd/es/form';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import iconArrive from '../../assets/images/booking/icon-arrive.svg';
import iconDepart from '../../assets/images/booking/icon-depart.svg';
import iconDown from '../../assets/images/booking/icon-down.svg';
import iconEmail from '../../assets/images/booking/icon-mail.svg';
import iconName from '../../assets/images/booking/icon-name.svg';
import iconPhone from '../../assets/images/booking/icon-phone.svg';
import iconBookingAgent from '../../assets/images/ic-booking-agent.svg';
import iconCancelPinCode from '../../assets/images/ic-cancel-pincode.svg';
import iconNumpad from '../../assets/images/ic-numpad.svg';
import '../../assets/styles/desktop/busBooking.scss';
import ModalInfoInsurance from '../../components/Modal/ModalInfoInsurance';
import ModalNumpad from '../../components/Modal/ModalNumpad';
import { Constant, USER_GROUP } from '../../config/constant';
import { convertTimeFormat, filterOption, filterOptionAgent, formattedPrice } from '../../lib/utils';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { listAgentSelector } from '../../redux/slice/agents/listAgentSlice';
import { selectAuth } from '../../redux/slice/authSlice';
import {
  createBookingSelector,
  filterBookingCustomer,
  getPriceBooking,
  setPinCode,
} from '../../redux/slice/bookings/createBookingSlice';
import { getAssistBookingSelector, resetAssistBooking } from '../../redux/slice/bookings/getAssistBookingSlice';
import { getTicketCodeSelector } from '../../redux/slice/bookings/getTicketCodeSlice';
import { paymentAgentOptions, paymentMultiOptions, validatorEmailBooking } from '../../utils/bookingItem';
import { getPriceScheduleReason } from '../../utils/helpers';

function ModalMultiBooking1({
  dataBooking,
  formBooking,
  listBooking,
  numCustomer,
  loadingHold,
  openModalNumpad,
  setOpenModalNumpad,
  modalOpen,
}: any) {
  const { t } = useTranslation();
  const { group } = useAppSelector(selectAuth);
  const {
    loading: loadingCreate,
    listCustomers,
    booking_for_agent_id,
    pin_code,
    statusPin,
  } = useAppSelector(createBookingSelector);
  const { listAgentActive } = useAppSelector(listAgentSelector);
  const { ticketCode, loading: loadingTicket } = useAppSelector(getTicketCodeSelector);
  const { listDataSegmentBooking } = useAppSelector((state) => state.checkBooking);
  const { listAssistBooking, segmentId, assistTransshipDepart, assistTransshipArrive } =
    useAppSelector(getAssistBookingSelector);
  const dispatch = useAppDispatch();
  const [paymentMethod, setPaymentMethod] = useState(0);
  const [openInfoInsurance, setOpenInfoInsurance] = useState(false);
  const [customerPhone, setCustomerPhone] = useState<string | undefined>(undefined);
  const isMultiInsurance = Form.useWatch('is_insurance_multi', formBooking);
  const num = Form.useWatch('num_customer', formBooking);
  const isRepresent = Form.useWatch('is_represent', formBooking);
  const isAgentId = Form.useWatch('is_agent_id_multi', formBooking);
  const watchSegmentId = Form.useWatch('segment_id', formBooking);
  const [otp, setOtp] = useState<string>('');
  const [listLocationDepart, setListLocationDepart] = useState<any>([]);
  const [listLocationArrive, setListLocationArrive] = useState<any>([]);

  const onChangePayment = ({ target: { value } }: RadioChangeEvent) => {
    setPaymentMethod(value);
  };
  const onChangeInsurance = () => {
    dispatchGetPriceBooking();
  };
  const handleOptionDropOff = () => {
    let options: any = [];
    if (listLocationArrive?.length) {
      options = options.concat(
        listLocationArrive?.length
          ? listLocationArrive?.map((item: any) => {
              return {
                value: item.id,
                label: `(${convertTimeFormat(item?.pickup_time)}) ${item?.pickup_location_name}`,
              };
            })
          : [],
      );
    }
    if (listBooking?.schedule?.is_arrive_transship) {
      options.push({
        value: 'other',
        label: 'Nhập điểm trung chuyển khác',
      });
    }
    return options;
  };
  const handleOptionPickup = () => {
    let options: any = [];
    if (listLocationDepart?.length) {
      options = options.concat(
        listLocationDepart?.length
          ? listLocationDepart?.map((item: any) => {
              return {
                value: item.id,
                label: `(${convertTimeFormat(item?.pickup_time)}) ${item?.pickup_location_name}`,
              };
            })
          : [],
      );
    }
    if (listBooking?.schedule?.is_depart_transship) {
      options.push({
        value: 'other',
        label: 'Nhập điểm trung chuyển khác',
      });
    }
    return options;
  };
  const groupSeatOption = () => {
    return listBooking?.schedule?.bus_type?.seat_map?.group_seat?.length
      ? listBooking?.schedule?.bus_type?.seat_map?.group_seat?.map((group: any) => ({
          label: <span className={group.group_color}>{group.name}</span>,
          value: group.name,
          // disabled: listAmountGroupSeat?.[group.name] === 0,
        }))
      : [];
  };
  const onChangeIsAgent = () => {
    const currentChecked = formBooking.getFieldValue('is_agent_id_multi');
    formBooking.setFieldValue('is_agent_id_multi', !currentChecked);
  };
  const handlePickupChange = () => {
    dispatchGetPriceBooking();
  };
  const onChangeGroupSeat = () => {
    dispatchGetPriceBooking();
  };
  const handleChangeSegment = (value: any, option: any) => {
    setListLocationDepart(option?.transship_depart?.length > 0 ? option?.transship_depart : []);
    setListLocationArrive(option?.transship_arrive?.length > 0 ? option?.transship_arrive : []);
  };
  const handleDropOffChange = () => {
    dispatchGetPriceBooking();
  };
  useEffect(() => {
    if (dataBooking?.seat_number?.length > 1) {
      const currentValues = formBooking.getFieldValue('custom_info') || [];
      dataBooking?.seat_number?.map(
        (item: any, index: any) =>
          (currentValues[index] = {
            seat: item,
            ticket_code: dataBooking?.ticket_code,
          }),
      );
    }
  }, [dataBooking, formBooking]);

  const NameRules: Rule[] = [
    {
      required: true,
      message: t('Vui lòng nhập tên'),
    },
    {
      pattern: /^[^\s].*$/,
      message: t('Tên không được chứa chỉ khoảng trắng'),
    },
  ];
  const dispatchGetPriceBooking = () => {
    const pickUpValue = formBooking.getFieldValue('pickUpValue');
    const dropOffValue = formBooking.getFieldValue('dropOffValue');
    const customInfo = formBooking.getFieldValue('custom_info');
    const isMultiInsurance = formBooking.getFieldValue('is_insurance_multi');
    const segmentId = formBooking.getFieldValue('segment_id');
    const scheduleId = listBooking?.schedule?.id;
    const seatNumber = dataBooking?.map((item: any) => item?.seat_number);
    if (
      scheduleId &&
      dataBooking &&
      pickUpValue !== null &&
      dropOffValue !== null &&
      customInfo?.length > 0 &&
      segmentId
    ) {
      const customInfoObject = customInfo.reduce((acc: any, obj: any, index: number) => {
        const pickupLocationId = obj.pickup_location_id === 'other' ? null : obj.pickup_location_id;
        const dropOffLocationId = obj.drop_off_location_id === 'other' ? null : obj.drop_off_location_id;
        if (obj?.seat && seatNumber) {
          const { seat } = obj;
          acc[seat] = {
            pickup_location_id: pickupLocationId,
            drop_off_location_id: dropOffLocationId,
            group_seat: obj.group_seat,
          };
        } else {
          acc[index] = {
            pickup_location_id: pickupLocationId,
            drop_off_location_id: dropOffLocationId,
            group_seat: obj.group_seat,
          };
        }
        return acc;
      }, {});

      dispatch(
        getPriceBooking({
          segment_id: segmentId,
          booking_type: Constant.BOOKING_MULTI_CUSTOM,
          schedule_id: scheduleId,
          seat_number: seatNumber,
          custom_info: customInfoObject,
          is_insurance: isMultiInsurance,
          depart_date: dayjs(listBooking?.schedule?.depart_date, 'DD/MM/YYYY').format('YYYY-MM-DD'),
          amount: num,
        }),
      );
    }
  };
  const listSegmentOption = listDataSegmentBooking?.length
    ? listDataSegmentBooking?.map((item: any) => {
        return {
          value: item?.segment_id,
          label: `${item?.start_location?.name} - ${item?.end_location?.name}`,
          transship_depart: item?.transship_depart,
          transship_arrive: item?.transship_arrive,
          time: item?.time,
          available_seats: item?.available_seats,
          price_schedule: item?.price_schedule,
        };
      })
    : [];
  const onCheckboxChange = (e: CheckboxChangeEvent) => {
    formBooking.setFieldsValue({ is_represent: e.target.checked });
  };
  const handleChangeAgentIdOption = (option: any) => {};

  // const onCheckboxAgentIdChange = (e: CheckboxChangeEvent) => {
  //   formBooking.setFieldsValue({ is_agent_id_multi: e.target.checked });
  // };
  const listAgentActiveOption = listAgentActive?.length
    ? listAgentActive?.map((item: any) => {
        return {
          commission_percent: item?.commission_percent,
          value: item?.id,
          label: (
            <div className="d-flex items-center gap-x-2">
              <img src={iconBookingAgent} alt="" />
              {item?.name}
            </div>
          ),
          searchText: item?.name?.toLowerCase() || '',
        };
      })
    : [];
  useEffect(() => {
    if (dataBooking?.length > 1) {
      const initialValues = dataBooking?.map((item: any, index: any) => ({
        seat: item?.seat_number,
        ticket_code: item?.ticket_code,
      }));
      formBooking.setFieldsValue({ custom_info: initialValues });
    } else if (numCustomer) {
      const initialValues = Array.from({ length: numCustomer }, () => ({}));
      formBooking.setFieldsValue({ custom_info: initialValues });
    }
  }, [dataBooking, formBooking, numCustomer]);

  useEffect(() => {
    if (!listBooking?.schedule?.is_diagram && ticketCode) {
      const initialValues = ticketCode?.map((ticketCodeItem: string) => ({
        ticket_code: ticketCodeItem,
      }));
      formBooking.setFieldsValue({ custom_info: initialValues });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [listBooking, ticketCode]);
  useEffect(() => {
    dispatch(filterBookingCustomer({}));
  }, [dispatch]);

  useEffect(() => {
    if (booking_for_agent_id) {
      formBooking.setFieldValue('agent_id_multi', booking_for_agent_id);
    }
  }, [booking_for_agent_id, formBooking]);
  const handleNumpadClick = () => {
    if (pin_code) {
      dispatch(setPinCode(null));
    } else {
      setOtp('');
      setOpenModalNumpad(true);
    }
  };
  useEffect(() => {
    if (statusPin) {
      setOpenModalNumpad(false);
    }
  }, [statusPin]);

  useEffect(() => {
    if (listBooking?.count_segment === 1 && listDataSegmentBooking?.length) {
      if (listDataSegmentBooking[0]?.segment_id) {
        formBooking.setFieldValue('segment_id', listDataSegmentBooking[0]?.segment_id);
        setListLocationDepart(
          listDataSegmentBooking[0]?.transship_depart?.length > 0 ? listDataSegmentBooking[0]?.transship_depart : [],
        );
        setListLocationArrive(
          listDataSegmentBooking[0]?.transship_arrive?.length > 0 ? listDataSegmentBooking[0]?.transship_arrive : [],
        );
      }
    }
  }, [listBooking?.count_segment, listDataSegmentBooking]);

  useEffect(() => {
    if (listAssistBooking?.length && segmentId && assistTransshipDepart && assistTransshipArrive && modalOpen) {
      formBooking.setFieldValue('segment_id', segmentId);
      setListLocationDepart(assistTransshipDepart?.length > 0 ? assistTransshipDepart : []);
      setListLocationArrive(assistTransshipArrive?.length > 0 ? assistTransshipArrive : []);
      if (watchSegmentId) {
        dispatch(resetAssistBooking());
      }
    }
  }, [
    dispatch,
    formBooking,
    listAssistBooking,
    watchSegmentId,
    segmentId,
    assistTransshipDepart,
    assistTransshipArrive,
    modalOpen,
  ]);

  return (
    <Spin spinning={loadingHold || loadingCreate || loadingTicket}>
      <div className="segment-booking-block mt-3">
        <div className="bg-segment">
          <span>Chọn chặng</span>
        </div>
        <Col className="d-none">
          <Form.Item name="is_represent">
            <Checkbox onChange={onCheckboxChange}>{t('Lấy thông tin khách hàng 1 làm thông tin chung')}</Checkbox>
          </Form.Item>
        </Col>
        <Row gutter={16}>
          <Col span={16}>
            <Form.Item name="segment_id" className="form-item-name require" validateTrigger={['onChange', 'onBlur']}>
              <Select
                className="input-h40"
                placeholder="Chọn chặng"
                size="large"
                style={{ width: '100%' }}
                options={[...listSegmentOption]}
                showSearch
                filterOption={filterOption}
                suffixIcon={<img src={iconDown} alt="" />}
                onChange={(value, option) => handleChangeSegment(value, option)}
                optionRender={(option) => (
                  <>
                    <Space className="w-100 fw-500 text-color-default d-flex justify-between">
                      <div>
                        {`${option?.data?.label}`}
                        {option?.data?.price_schedule?.reason ? (
                          <div className="text-success fs-13 fw-500">
                            {getPriceScheduleReason(option?.data?.price_schedule, false)}
                          </div>
                        ) : (
                          ''
                        )}
                      </div>
                      <div className="available-seat-segment">{`Còn ${option?.data?.available_seats} chỗ`}</div>
                    </Space>
                  </>
                )}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            {group === USER_GROUP.CAR_COMPANY ? (
              <div className="agent-booking-block">
                <div onClick={onChangeIsAgent} className={`h-fit`}>
                  <Form.Item
                    name="is_agent_id_multi"
                    className="is-agent d-flex items-center justify-center"
                    valuePropName="checked"
                  >
                    <Checkbox />
                  </Form.Item>
                </div>
                <Form.Item name="agent_id" className="is-agent-select" required={isAgentId ? true : false}>
                  <Select
                    className="input-h40"
                    disabled={!isAgentId}
                    placeholder={
                      <div
                        className="d-flex justify-center items-center "
                        style={{ columnGap: '10px', width: '150px' }}
                      >
                        <img src={iconBookingAgent} alt="" /> Đặt hộ đại lý
                      </div>
                    }
                    size="large"
                    options={[...listAgentActiveOption]}
                    showSearch
                    onChange={(value, option) => handleChangeAgentIdOption(option)}
                    filterOption={filterOptionAgent}
                    suffixIcon={<img src={iconDown} alt="" />}
                  />
                </Form.Item>
              </div>
            ) : (
              ''
            )}
          </Col>
        </Row>
      </div>

      <div
        className="ticket-info-booking-block mt-4"
        style={{ maxHeight: '350px', overflowY: 'auto', overflowX: 'hidden' }}
      >
        <Form.List name="custom_info">
          {(fields) => (
            <>
              {fields?.map(({ key, name, fieldKey, ...restField }, index) => {
                return (
                  <div key={key}>
                    <Row gutter={16} className="d-none">
                      <Col span={5}>
                        <Form.Item
                          {...restField}
                          name={[name, 'seat']}
                          label={t('Ghế đang chọn')}
                          className="w-100 booking-input-disable"
                        >
                          <Input disabled />
                        </Form.Item>
                      </Col>
                      <Col>
                        <Form.Item {...restField} name={[name, 'ticket_code']} label={t('Mã vé')}>
                          <Input disabled />
                        </Form.Item>
                      </Col>
                    </Row>
                    <Flex align="center" justify="space-between">
                      <div className="bg-ticket">
                        <span>{`Mã vé: ${formBooking.getFieldValue(['custom_info', index, 'ticket_code']) ?? ''} ${
                          !listBooking?.schedule?.is_diagram
                            ? ''
                            : ` - Ghế: ${formBooking.getFieldValue(['custom_info', index, 'seat']) ?? ''}`
                        } `}</span>
                      </div>
                      {index === 0 && (
                        <Form.Item name="is_represent">
                          <Checkbox onChange={onCheckboxChange}>
                            {t('Lấy thông tin khách hàng 1 làm thông tin chung')}
                          </Checkbox>
                        </Form.Item>
                      )}
                    </Flex>
                    <Row gutter={12} className="mt-3">
                      <Col span={8}>
                        <Form.Item
                          {...restField}
                          name={[name, 'customer_phone']}
                          className="require"
                          validateTrigger={['onChange', 'onBlur']}
                        >
                          <Input
                            className="input-h40 phone-select"
                            placeholder={t('Nhập số điện thoại')}
                            size="large"
                            addonBefore={<img src={iconPhone} alt="" />}
                            value={customerPhone}
                            onChange={(e) => {
                              const value = e.target.value;
                              setCustomerPhone(value);
                            }}
                            onWheel={(event) => event.currentTarget.blur()}
                            onKeyPress={(event) => {
                              if (!/[0-9]/.test(event.key)) {
                                event.preventDefault();
                              }
                            }}
                            onBlur={(e) => {
                              const value = e.target.value;
                              const currentValue = formBooking.getFieldValue('custom_info');
                              const selectedCustomer =
                                listCustomers?.length &&
                                listCustomers.find((customer: any) => customer.phone === value);
                              if (selectedCustomer) {
                                currentValue[index] = {
                                  ...currentValue[index],
                                  customer_name: selectedCustomer.name,
                                  customer_email: selectedCustomer.email,
                                  customer_phone: selectedCustomer.phone,
                                };
                              } else {
                                currentValue[index] = {
                                  ...currentValue[index],
                                  customer_phone: value,
                                };
                              }
                              formBooking.setFieldsValue({
                                custom_info: currentValue,
                              });
                            }}
                          />
                        </Form.Item>
                      </Col>
                      <Col span={8}>
                        <Form.Item
                          {...restField}
                          name={[name, 'customer_name']}
                          className="require"
                          rules={isRepresent ? (index === 0 ? NameRules : undefined) : NameRules}
                          validateTrigger={['onChange', 'onBlur']}
                        >
                          <Input
                            placeholder="Nhập họ và tên"
                            className="input-h40"
                            addonBefore={<img src={iconName} alt="" />}
                          />
                        </Form.Item>
                      </Col>
                      <Col span={8}>
                        <Form.Item
                          {...restField}
                          name={[name, 'customer_email']}
                          rules={validatorEmailBooking}
                          validateTrigger={['onChange', 'onBlur']}
                        >
                          <Input
                            placeholder="Nhập email"
                            className="input-h40"
                            addonBefore={<img src={iconEmail} alt="" />}
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row gutter={16} className="mt-3">
                      <Col span={12}>
                        <Form.Item
                          {...restField}
                          name={[name, 'pickup_location_id']}
                          className="form-item-name require"
                        >
                          <Select
                            showSearch
                            placeholder={
                              <>
                                <img src={iconDepart} alt="" style={{ marginTop: '-1px', paddingRight: 5 }} /> Chọn điểm
                                đón
                              </>
                            }
                            filterOption={filterOption}
                            className="input-h40"
                            size="large"
                            style={{ width: '100%' }}
                            options={handleOptionPickup()}
                            onChange={handlePickupChange}
                            suffixIcon={<img src={iconDown} alt="" />}
                            disabled={!watchSegmentId}
                          />
                        </Form.Item>
                      </Col>
                      <Col span={12}>
                        <Form.Item
                          {...restField}
                          name={[name, 'drop_off_location_id']}
                          className="form-item-name require"
                        >
                          <Select
                            showSearch
                            filterOption={filterOption}
                            className="input-h40"
                            placeholder={
                              <>
                                <img src={iconArrive} alt="" style={{ marginTop: '-1px', paddingRight: 5 }} /> Chọn điểm
                                trả
                              </>
                            }
                            size="large"
                            style={{ width: '100%' }}
                            options={handleOptionDropOff()}
                            onChange={handleDropOffChange}
                            suffixIcon={<img src={iconDown} alt="" />}
                            disabled={!watchSegmentId}
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row gutter={16} style={{ display: 'flex' }} className="mt-3">
                      {formBooking.getFieldValue(['custom_info', index, 'pickup_location_id']) === 'other' && (
                        <Col span={12}>
                          <Form.Item
                            name={[name, 'pickup_extra']}
                            className="form-item-name require"
                            validateTrigger={['onChange', 'onBlur']}
                          >
                            <Input
                              className="input-h40"
                              placeholder="Chọn điểm đón khác"
                              size="large"
                              style={{ width: '100%', borderLeft: '1px solid #C3CAD7' }}
                            />
                          </Form.Item>
                        </Col>
                      )}
                      {formBooking.getFieldValue(['custom_info', index, 'drop_off_location_id']) === 'other' &&
                        formBooking.getFieldValue(['custom_info', index, 'pickup_location_id']) !== 'other' && (
                          <Col span={12}></Col>
                        )}
                      {formBooking.getFieldValue(['custom_info', index, 'drop_off_location_id']) === 'other' && (
                        <Col span={12}>
                          <Form.Item
                            name={[name, 'drop_off_extra']}
                            className="form-item-name require"
                            validateTrigger={['onChange', 'onBlur']}
                          >
                            <Input
                              className="input-h40"
                              placeholder="Nhập điểm trả khác"
                              size="large"
                              style={{ width: '100%', borderLeft: '1px solid #C3CAD7' }}
                            />
                          </Form.Item>
                        </Col>
                      )}
                    </Row>
                    {!listBooking?.schedule?.is_diagram ? (
                      <Row className="w-100 mt-0">
                        <Col span={3}>
                          <Typography className="fs-16 fw-500 text-blue">Loại ghế:</Typography>{' '}
                        </Col>
                        <Col span={21}>
                          <Form.Item
                            {...restField}
                            name={[name, 'group_seat']}
                            className="payment-checkbox-group group_seat"
                          >
                            <Radio.Group options={groupSeatOption()} onChange={onChangeGroupSeat} />
                          </Form.Item>
                        </Col>
                      </Row>
                    ) : (
                      ''
                    )}
                  </div>
                );
              })}
            </>
          )}
        </Form.List>
      </div>
      <div className="payment-booking-block mt-4">
        <div className="bg-payment">
          <span>Thanh toán</span>
        </div>
        <Row gutter={20} className="w-100 mt-3">
          <Col span={6}>
            {group !== USER_GROUP.AGENT ? (
              <Flex className="block-numpad-input">
                <Form.Item name="price_multi" label={t('Tổng tiền')} className="booking-input-disable price">
                  <InputNumber
                    suffix="VND"
                    disabled={!pin_code}
                    formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                    parser={(value) => value?.replace(/[^0-9]/g, '') as unknown as number}
                    onKeyPress={(event) => {
                      if (!/[0-9]/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                  />
                </Form.Item>
                <div className="btn-numpad" onClick={() => handleNumpadClick()} style={{ marginTop: '25px' }}>
                  <img src={pin_code ? iconCancelPinCode : iconNumpad} alt="" />
                </div>
              </Flex>
            ) : (
              <>
                <Form.Item name="price_multi" label={t('Tổng tiền vé')} className="price">
                  <Input suffix="VND" disabled />
                </Form.Item>
              </>
            )}
            {isMultiInsurance && listBooking?.schedule?.is_diagram && (
              <Typography className="fs-14 fw-500 text-insurance">
                {listBooking?.policy?.insurance_policy?.percent && dataBooking?.length
                  ? `+${+listBooking?.policy?.insurance_policy?.percent * +dataBooking?.length}% tiền bảo hiểm`
                  : `+${formattedPrice(
                      +listBooking?.policy?.insurance_policy?.price * +dataBooking?.length,
                    )}đ tiền bảo hiểm`}
              </Typography>
            )}
            {isMultiInsurance && !listBooking?.schedule?.is_diagram && (
              <Typography className="fs-14 fw-500 text-insurance">
                {listBooking?.policy?.insurance_policy?.percent
                  ? `+${+listBooking?.policy?.insurance_policy?.percent * +num}% tiền bảo hiểm`
                  : `+${+listBooking?.policy?.insurance_policy?.price * +num}đ tiền bảo hiểm`}
              </Typography>
            )}
          </Col>
          {group === USER_GROUP.AGENT && (
            <Col span={6}>
              <Form.Item
                name="commission_price"
                label={t('Tổng tiền đại lý trả')}
                className="booking-input-disable price"
              >
                <Input suffix="VND" disabled className="input-h40 d-flex items-center border-r-2" />
              </Form.Item>
              <Typography className="fs-14 fw-500 text-discount">
                {`Đã trừ ${
                  listBooking?.schedule?.agent?.commission_percent
                    ? listBooking?.schedule?.agent?.commission_percent
                    : '0'
                }% chiết khấu`}
              </Typography>
            </Col>
          )}
          {(listBooking?.policy?.insurance_policy?.percent || listBooking?.policy?.insurance_policy?.price) && (
            <Col className="d-flex">
              <Space className={group === USER_GROUP.AGENT ? '' : 'mt-3'}>
                <Form.Item name="is_insurance_multi" className="booking-input-disable">
                  <Switch
                    defaultChecked={false}
                    onChange={onChangeInsurance}
                    className="mt-3"
                    disabled={
                      !listBooking?.policy?.insurance_policy?.percent && !listBooking?.policy?.insurance_policy?.price
                    }
                  />
                </Form.Item>
                <Typography.Text className="fw-500 fs-14 ">
                  {t(
                    `Bảo hiểm chuyến đi (${
                      listBooking?.policy?.insurance_policy?.percent
                        ? `${listBooking?.policy?.insurance_policy?.percent}% giá vé`
                        : `${formattedPrice(listBooking?.policy?.insurance_policy?.price)}đ/ghế`
                    }) `,
                  )}
                </Typography.Text>
                <Tooltip title={'Xem chi tiết chính sách bảo hiểm'}>
                  <InfoCircleFilled style={{ color: '#F8B507' }} onClick={() => setOpenInfoInsurance(true)} />
                </Tooltip>
              </Space>
            </Col>
          )}
          <Col span={18}>
            <Form.Item name={'note'} label={t('Ghi chú')}>
              <Input placeholder="Nhập ghi chú" />
            </Form.Item>
          </Col>
        </Row>
        <Row className="mt-2 ">
          <Col>
            <Form.Item name="payment_method_multi" label={t('Phương thức thanh toán')} className="require">
              <Radio.Group
                options={group !== USER_GROUP.AGENT ? paymentMultiOptions : paymentAgentOptions}
                onChange={onChangePayment}
                value={paymentMethod}
                buttonStyle="solid"
                className="payment-checkbox-group"
              />
            </Form.Item>
          </Col>
        </Row>
      </div>
      <ModalNumpad
        modalOpen={openModalNumpad}
        onCancel={() => {
          setOpenModalNumpad(false);
          setOtp('');
        }}
        onOk={() => false}
        otp={otp}
        setOtp={setOtp}
      />
      <ModalInfoInsurance
        modalOpen={openInfoInsurance}
        onCancel={() => setOpenInfoInsurance(false)}
        onOk={() => false}
        listBooking={listBooking}
      />
    </Spin>
  );
}

export default ModalMultiBooking1;
